export class NotificationModel {
    public createdDate!: string;
    public id!: number;
    public isBuy!: any;
    public mainOrder!: any;
    public message!: string;
    public orderId!: number;
    public orderType!: any;
    public receivedId!: number;
    public status!: number;
    public statusDetail!: any;
}
